module.exports = __webpack_public_path__ + "img/tour-48.30393932.png";